module.exports = __webpack_public_path__ + "static/media/catalog.4863ecbc.png";